export const accessSystems = {
  registry: "registry",
  legacy: "legacy",
} as const;
export type AccessSystem = keyof typeof accessSystems;

export const accessScopes = {
  paywall: "paywall",
  access_group: "access_group",
  other: "other",
} as const;
export type AccessScope = keyof typeof accessScopes;

export const contentSpecTypes = {
  Space: "Space",
  SpaceGroup: "SpaceGroup",
  AccessGroup: "AccessGroup",
} as const;
export type ContentSpecType = keyof typeof contentSpecTypes;

export const contentTypes = {
  SpaceMember: "SpaceMember",
  SpaceGroupMember: "SpaceGroupMember",
  AccessGroupCommunityMember: "AccessGroupCommunityMember",
} as const;
export type ContentType = keyof typeof contentTypes;

export interface ChangeEvent {
  access_spec_id: number;
  access_spec_type: string;
  actor_id: number;
  actor_type: string;
  id: number;
  type: string;
}

export interface AccessSpec {
  id: number;
  name: string;
  type: ContentSpecType;
}

interface AccessRegistryCommunityMemberStateEntrySpaceContentSpec
  extends AccessSpec {
  type: "Space";
  type_label: string;
}
interface AccessRegistryCommunityMemberStateEntrySpaceGroupContentSpec
  extends AccessSpec {
  type: "SpaceGroup";
}
interface AccessRegistryCommunityMemberStateEntryAccessGroupContentSpec
  extends AccessSpec {
  spaces_count: number;
  type: "AccessGroup";
}

export type AccessRegistryCommunityMemberStateEntryContentSpec =
  | AccessRegistryCommunityMemberStateEntrySpaceContentSpec
  | AccessRegistryCommunityMemberStateEntrySpaceGroupContentSpec
  | AccessRegistryCommunityMemberStateEntryAccessGroupContentSpec;

export interface AccessRegistryCommunityMemberStateEntryContent {
  access_scope: AccessScope;
  access_system: AccessSystem;
  created_at: string;
  grant_events: ChangeEvent[];
  id: number;
  type: ContentType;
}

interface AccessRegistryCommunityMemberBaseStateEntry {
  content?: AccessRegistryCommunityMemberStateEntryContent;
  content_spec: AccessRegistryCommunityMemberStateEntryContentSpec;
}

export interface AccessRegistryCommunityMemberSpaceStateEntry
  extends AccessRegistryCommunityMemberBaseStateEntry {
  content_spec: AccessRegistryCommunityMemberStateEntrySpaceContentSpec;
}

export interface AccessRegistryCommunityMemberSpaceGroupStateEntry
  extends AccessRegistryCommunityMemberBaseStateEntry {
  content_spec: AccessRegistryCommunityMemberStateEntrySpaceGroupContentSpec;
  spaces: Record<string, AccessRegistryCommunityMemberSpaceStateEntry>;
}

export interface AccessRegistryCommunityMemberAccessGroupStateEntry
  extends AccessRegistryCommunityMemberBaseStateEntry {
  content_spec: AccessRegistryCommunityMemberStateEntryAccessGroupContentSpec;
  space_groups: Record<
    string,
    AccessRegistryCommunityMemberSpaceGroupStateEntry
  >;
}

export interface AccessRegistryCommunityMemberState {
  access_groups: Record<
    string,
    AccessRegistryCommunityMemberAccessGroupStateEntry
  >;
  content_specs_granted_through_access_groups: Array<
    | AccessRegistryCommunityMemberStateEntrySpaceGroupContentSpec
    | AccessRegistryCommunityMemberStateEntrySpaceContentSpec
  >;

  space_groups: Record<
    string,
    AccessRegistryCommunityMemberSpaceGroupStateEntry
  >;
}

interface BaseContentSpecAccessDetails {
  id: number;
  name: string;
  type: ContentSpecType;
}

export interface AccessGroupAccessDetails extends BaseContentSpecAccessDetails {
  name: string;
  spaces?: SpaceAccessDetails[];
  type: "AccessGroup";
}

export interface SpaceAccessDetails extends BaseContentSpecAccessDetails {
  access_groups: AccessGroupAccessDetails[];
  space_group: SpaceGroupAccessDetails;
}

export interface SpaceGroupAccessDetails extends BaseContentSpecAccessDetails {
  access_groups: AccessGroupAccessDetails[];
}

export type ContentSpecAccessDetails =
  | AccessGroupAccessDetails
  | SpaceGroupAccessDetails
  | SpaceAccessDetails;
